/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentSystemBlocks.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for System Block API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Sunday, September 23, 2018 - 2:58 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/23/2018  NJN     File Created
 *      09/24/2018  NJN     Add SystemBlockValidationTypes
 *      09/30/2018  NJN     Add Blocks, BlockPath, BlockElements
 *      10/28/2018  NJN     Add BlockDatas
 *      11/14/2018  NJN     Add BlockFormats
 *      03/30/2019  NJN     Add BlockDataValues
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const SystemBlockValidationTypes = {
    all: () => requests.get('/SystemBlockValidationTypes'),
    get: validationtypeid => requests.get(`/SystemBlockValidationType/${validationtypeid}`),
    create: validationtype => requests.post(`/SystemBlockValidationTypes`, validationtype),
    update: (validationtypeid, validationtype) => requests.put(`/SystemBlockValidationType/${validationtypeid}`, validationtype),
    delete: validationtypeid => requests.del(`/SystemBlockValidationType/${validationtypeid}`),
};

export const BlockValidationTypeFields = {
    all: (validationtypeid) => requests.get(`/ValidationFields?validationtypeid=${validationtypeid}`),
    get: validationfieldid => requests.get(`/ValidationField/${validationfieldid}`),
    create: validationfield => requests.post(`/ValidationFields`, validationfield),
    update: (validationfieldid, validationfield) => requests.put(`/ValidationField/${validationfieldid}`, validationfield),
    delete: validationfieldid => requests.del(`/ValidationField/${validationfieldid}`),
};

export const BlockElementOptions = {
    all: () => requests.get('/ElementOptions'),
    get: elementoptionid => requests.get(`/ElementOption/${elementoptionid}`),
    create: elementoption => requests.post(`/ElementOptions`, elementoption),
    update: (elementoptionid, elementoption) => requests.put(`/ElementOption/${elementoptionid}`, elementoption),
    delete: elementoptionid => requests.del(`/ElementOption/${elementoptionid}`),
};

export const BlockElementTypes = {
    all: () => requests.get('/ElementTypes'),
    get: elementtypeid => requests.get(`/ElementType/${elementtypeid}`),
    create: elementtype => requests.post(`/ElementTypes`, elementtype),
    update: (elementtypeid, elementtype) => requests.put(`/ElementType/${elementtypeid}`, elementtype),
    delete: elementtypeid => requests.del(`/ElementType/${elementtypeid}`),
};

export const BlockGroups = {
    all: (parentid) => requests.get(`/BlockGroups?parentid=${parentid}`),
    get: blockgroupid => requests.get(`/BlockGroup/${blockgroupid}`),
    getByName: blockgroup => requests.get(`/BlockGroupByName`, blockgroup),
    create: blockgroup => requests.post(`/BlockGroups`, blockgroup),
    update: (blockgroupid, blockgroup) => requests.put(`/BlockGroup/${blockgroupid}`, blockgroup),
    delete: (blockgroupid, parentid) => requests.del(`/BlockGroup/${blockgroupid}?parentid=${parentid}`),
};

export const BlockGroupPath = {
    get: parentid => requests.get(`/BlockGroupPath/${parentid}`)
};

export const BlockGroupTree = {
    get: parentid => requests.get(`/BlockGroupTree/${parentid}`)
};

export const BlockGroupTabGroups = {
    get: () => requests.get(`/BlockGroupTabGroups`)
};

export const BlockGroupTabs = {
    get: tabgroupid => requests.get(`/BlockGroupTabs/${tabgroupid}`)
};

export const Blocks = {
    all: (blockgroupid, parentid) => requests.get(`/Blocks?blockgroupid=${blockgroupid}&parentid=${parentid}`),
    get: blockid => requests.get(`/Block/${blockid}`),
    create: block => requests.post(`/Blocks`, block),
    update: (blockid, block) => requests.put(`/Block/${blockid}`, block),
    delete: (blockid, blockgroupid, parentid) => requests.del(`/Block/${blockid}?blockgroupid=${blockgroupid}&parentid=${parentid}`),
};

export const BlockPath = {
    get: parentid => requests.get(`/BlockPath/${parentid}`)
};

export const BlockTree = {
    get: (blockgroupid, parentid) => requests.get(`/BlockTree?blockgroupid=${blockgroupid}&parentid=${parentid}`)
};

export const BlockElements = {
    get: blockelementid => requests.get(`/BlockElement/${blockelementid}`),
    getOptions: blockelementtypeid => requests.get(`/BlockElementOptions/${blockelementtypeid}`),
    getValidationTypes: blockelementtypeid => requests.get(`/BlockElementValidations/${blockelementtypeid}`),
    create: blockelement => requests.post(`/BlockElements`, blockelement),
    update: (blockelementid, blockelement) => requests.put(`/BlockElement/${blockelementid}`, blockelement),
    delete: (blockelementid, blockgroupid, blockid) => requests.del(`/BlockElement/${blockelementid}?blockgroupid=${blockgroupid}&blockid=${blockid}`),
};

export const BlockDatas = {
    all: (blockgroupid) => requests.get(`/BlockDatas?blockgroupid=${blockgroupid}`),
    get: blockdataid => requests.get(`/BlockData/${blockdataid}`),
    create: blackdata => requests.post(`/BlockDatas`, blackdata),
    update: (blockdataid, blackdata) => requests.put(`/BlockData/${blockdataid}`, blackdata),
    delete: blockdataid => requests.del(`/BlockData/${blockdataid}`),
};

export const BlockDataValues = {
    get: datarequest => requests.post('/BlockDataValueExtended', datarequest),
}

export const BlockFormats = {
    all: () => requests.get('/BlockFormats'),
    get: blockformatid => requests.get(`/BlockFormat/${blockformatid}`),
    create: blockformat => requests.post(`/BlockFormats`, blockformat),
    update: (blockformatid, blockformat) => requests.put(`/BlockFormat/${blockformatid}`, blockformat),
    delete: blockformatid => requests.del(`/BlockFormat/${blockformatid}`),
};

export const BlockFormatLevels = {
    all: (blockformatid) => requests.get(`/BlockFormatLevels?blockformatid=${blockformatid}`),
    get: blockformatlevelid => requests.get(`/BlockFormatLevel/${blockformatlevelid}`),
    create: blockformatlevel => requests.post(`/BlockFormatLevels`, blockformatlevel),
    update: (blockformatlevelid, blockformatlevel) => requests.put(`/BlockFormatLevel/${blockformatlevelid}`, blockformatlevel),
    delete: blockformatlevelid => requests.del(`/BlockFormatLevel/${blockformatlevelid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentSystemBlocks.js